export const BANNER_TRANSLATION_KEY = {
    'good_deals--allTags': {
        title: 'salePage.banner.good-deals.all-tags.title',
        text: 'salePage.banner.good-deals.all-tags.text',
    },
    'good_deals--bulk-offer': {
        title: 'salePage.banner.good-deals.bulk-offer.title',
        text: 'salePage.banner.good-deals.bulk-offer.text',
    },
    'good_deals--anti_waste': {
        title: 'salePage.banner.good-deals.anti-waste.title',
        text: 'salePage.banner.good-deals.anti-waste.text',
    },
    'good_deals--engaged-price': {
        title: 'salePage.banner.good-deals.engaged-price.title',
        text: 'salePage.banner.good-deals.engaged-price.text',
    },
    'good_deals--to_be_discovered': {
        title: 'salePage.banner.good-deals.to-be-discovered.title',
        text: 'salePage.banner.good-deals.to-be-discovered.text',
    },
    'good_deals--custom-event-tag': {
        title: 'salePage.banner.custom-event-tag.title',
        text: 'salePage.banner.custom-event-tag.text',
    },
    // custom-event-tag Need to be one translation for each event
    christmas: {
        title: 'salePage.banner.custom-event-tag.title',
        text: 'salePage.banner.custom-event-tag.text',
    },
    easter: {
        title: 'salePage.banner.custom-event-tag.title',
        text: 'salePage.banner.custom-event-tag.text',
    },
    summer: {
        title: 'salePage.banner.custom-event-tag.title',
        text: 'salePage.banner.custom-event-tag.text',
    },
};
